import { Component, Input, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { WebClient } from '@injectables';
import { Device, User } from '@models';
import { FragQueryService } from 'src/injectables/frag-query.service';

@Component({
    selector: 'target-interval-settings',
    templateUrl: './target-intervals.component.html',
    styleUrls: ['./target-intervals.component.scss']
})
export class TargetIntervalsComponent<T extends User | Device> implements OnChanges {
    device: Device;

    constructor(
        private readonly webClient: WebClient,
        private fragQuery: FragQueryService,
        private readonly dialog: DialogService,
        private readonly snackBar:MatSnackBar
    ) { }
    @Input() model: User | Device;
    @Input() saveFn!: (model: T) => Promise<boolean>;
    @Input() visibleDeviceDropDown : boolean
    public readonly devices$ = this.fragQuery.devices$;
    public readonly device$ = this.fragQuery.device$;
    public readonly deviceUuid$ = this.fragQuery.deviceUuid$;
    public readonly particleSizeUnitSystem$ = this.fragQuery.particleSizeUnitSystem$;
    public formGroup: FormGroup;
    public readonly restClient = this.webClient.model.device;
    public newTargetMinPr: number = 0;
    public newTargetMaxPr: number = 100;
    public newTargetSize: number = null;
    public preferCustomSizes:boolean =false;
    public sizeOptions: Array<{ targetMinPr: number, targetMaxPr: number, targetSize: number }> = [];
    public showAddSizeRange: boolean = false;
    public enableSaving: boolean = false;

    ngOnChanges(): void {
        if (this.model) {
            this.preferCustomSizes = this.model.preferCustomSizes;
            const sizeString = this.model.targetSizes;
            try {
                const parsedSize = JSON.parse(sizeString || '[]');
                this.sizeOptions = Array.isArray(parsedSize) &&
                    parsedSize[0]?.targetMinPr != null &&
                    parsedSize[0]?.targetMaxPr != null
                    ? parsedSize : [];
            } catch {
                this.sizeOptions = [];
            }
        }
    }

    async saveSettings() {
        try {
            this.model.preferCustomSizes = this.preferCustomSizes;
            const sortedSizeOptions = [...this.sizeOptions]?.sort((a, b) => a.targetSize - b.targetSize);
            this.model.targetSizes = JSON.stringify(sortedSizeOptions);
            await this.dialog.await(this.saveFn(this.model as T));
            this.snackBar.open('Settings saved successfully', 'OK', {
                duration: 5000,
                panelClass: ['snackbar-success']
            });
            this.fragQuery.trigger$.next();
        } catch (error) {
            console.error('Error saving settings:', error);
        }
    }

     addCustomSizeRange() {
        if (this.newTargetSize > 0 && this.newTargetMinPr!=null && this.newTargetMinPr>=0 && this.newTargetMinPr<=100 && this.newTargetMaxPr>=0 && this.newTargetMaxPr<=100 && this.newTargetMaxPr && (this.newTargetMinPr < this.newTargetMaxPr)) {
            const newRange = { targetMinPr: this.newTargetMinPr, targetMaxPr: this.newTargetMaxPr, targetSize: this.newTargetSize };
            this.sizeOptions = [...this.sizeOptions, newRange];
            this.newTargetMinPr=0;
            this.newTargetMaxPr=100;
            this.newTargetSize=null;
        } else {
            alert('Invalid size range');
        }
    }

    removeSizeRange(rangeToRemove: { targetMinPr: number; targetMaxPr: number; targetSize: number }) {
        this.sizeOptions = this.sizeOptions.filter(range => range !== rangeToRemove);
    }
    toggleAddSizeRange() {
        this.showAddSizeRange = !this.showAddSizeRange;
    }
}
